import CryptoJS from "crypto-js";
const secretKey = "zTqGvWOYpPym3Eb0";

export function decryptData(encryptedBase64) {
  return encryptedBase64?.data || encryptedBase64;
  // const key = CryptoJS.enc.Utf8.parse(secretKey);
  // const encryptedHex = CryptoJS.enc.Base64.parse(encryptedBase64);
  // const decrypted = CryptoJS.AES.decrypt({ ciphertext: encryptedHex }, key, {
  //   mode: CryptoJS.mode.ECB,
  //   padding: CryptoJS.pad.Pkcs7,
  // });
  // let data = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
  // return data;
}
